export default "__VITE_ASSET__D7Mc523G__"